import React from 'react';
import './UnitPriceCellRenderer.scss';

export const UnitPriceCellRenderer: React.FC = (props: any) => {
  const { data } = props;

  //Handling render box cell in first row for reverse table
  if (data.typeColumn && data.typeColumn === 'first-row') {
    return null;
  }

  //Handling render box cell in second row for reverse table
  if (data.typeColumn && data.typeColumn === 'second-row') {
    return null;
  }

  return (
    <div className="unit_price_container">
      {data.productVariations &&
        // Sort by quantity ASC
        data.productVariations.sort((a: any, b: any) => {
          // Check exists
          if (
            a.priceBreaks &&
            a.priceBreaks.length > 0 &&
            a.priceBreaks[0].quantity &&
            b.priceBreaks &&
            b.priceBreaks.length > 0 &&
            b.priceBreaks[0].quantity
          ) {
            return a.priceBreaks[0].quantity > b.priceBreaks[0].quantity ? 1 : -1;
          }
        })
        &&
        data.productVariations.map((item: any, index: number) => {
          const priceBreaks = item?.priceBreaks;
          const packageType = item?.packageType?.name;
          
          if (
            packageType &&
            !packageType.includes('Digi-Reel') &&
            priceBreaks
          ) {
            const price = priceBreaks[0]?.price.toFixed(
              Math.max(
                5,
                (priceBreaks[0]?.price.toString().split('.')[1] || []).length
              )
            );
            const quantity = priceBreaks[0]?.quantity;
            if (price && quantity) {
              return (
                <div className="unit_price_break" key={index}>
                  <div>
                    <span>{quantity}: </span>
                          <span className="unit_price_price">{priceBreaks[0]?.PriceWithSymbol}</span>
                  </div>
                  <div className="unit_price_package">{packageType}</div>
                </div>
              );
            }
          }
        })}
    </div>
  );
};
